import { render, staticRenderFns } from "./addData.vue?vue&type=template&id=f6d7d64a"
import script from "./addData.vue?vue&type=script&lang=js"
export * from "./addData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports